import "../../index90.css";
import { jsxs as _, Fragment as B, jsx as e } from "react/jsx-runtime";
import { useRef as m, useCallback as i } from "react";
import { CheckDoubleFillIcon as me, CloseLineIcon as de, ArrowUpSmallFillIcon as fe, ArrowDownSmallFillIcon as Ce } from "@ifrc-go/icons";
import { b as ge } from "../../core-DVmjA3_O.js";
import { _ as L } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import w from "../Button/index.js";
import he from "../InputContainer/index.js";
import ye from "../List/index.js";
import Ie from "../Popup/index.js";
import Me from "../RawInput/index.js";
import Se from "../../hooks/useBlurEffect.js";
import _e from "../../hooks/useKeyboard.js";
import we from "../../hooks/useTranslation.js";
import { extractInputContainerProps as Pe } from "../../utils/inputs.js";
import be from "./GenericOption/index.js";
const ke = "common", ve = {
  infoMessageAnd: "and",
  infoMessageMore: "more",
  buttonTitleSelect: "Select all",
  buttonTitleClear: "Clear",
  buttonTitleClose: "Close",
  buttonTitleOpen: "Open",
  selectInputPendingMessage: "Fetching options...",
  selectInputEmptyMessage: "No option available",
  selectInputFilteredMessage: "No option available for the search",
  selectInputErrorMessage: "Could not load options"
}, Fe = {
  namespace: ke,
  strings: ve
}, Re = "_popup_poyjv_1", Te = "_list_poyjv_4", Ne = "_list-item_poyjv_9", Oe = "_info-message_poyjv_14", xe = "_icon_poyjv_21", r = {
  popup: Re,
  list: Te,
  listItem: Ne,
  infoMessage: Oe,
  icon: xe
}, De = [];
function Ze(W) {
  const {
    actions: $,
    disabled: p,
    readOnly: a,
    required: H,
    ...q
  } = W, [G, U] = Pe(
    q
  ), {
    name: d,
    onOptionClick: P,
    searchText: z,
    onSearchTextChange: b,
    optionContainerClassName: k,
    optionKeySelector: v,
    optionRenderer: F,
    optionRendererParams: R,
    options: J,
    optionsPopupClassName: Q,
    persistentOptionPopup: u,
    placeholder: X,
    valueDisplay: f = "",
    nonClearable: Y,
    onClearButtonClick: Z,
    onSelectAllButtonClick: T,
    optionsPending: N = !1,
    optionsFiltered: ee = !1,
    optionsErrored: O = !1,
    focused: oe,
    focusedKey: C,
    onFocusedKeyChange: g,
    onFocusedChange: x,
    dropdownShown: o,
    onDropdownShownChange: t,
    totalOptionsCount: D = 0,
    hasValue: ne,
    autoFocus: te,
    onEnterWithoutOption: se,
    dropdownHidden: ie
  } = U, h = J ?? De, n = we(Fe), E = m(null), j = m(null), y = m(null), K = m(null), re = i(
    (s) => {
      o || t(!0), b(s);
    },
    [
      o,
      t,
      b
    ]
  ), ae = i(
    (s, l) => {
      l.stopPropagation(), t(!o);
    },
    [o, t]
  ), I = i(
    () => {
      o || t(!0);
    },
    [
      o,
      t
    ]
  ), c = i(
    () => {
      t(!1);
    },
    [t]
  ), le = i(
    () => {
      a || I();
    },
    [a, I]
  ), ce = i(
    (s, l) => {
      s || l ? u && y.current && y.current.focus() : c();
    },
    [c, u]
  ), M = i(
    (s, l) => {
      P(s, l, d), u || c();
    },
    [P, c, u, d]
  ), pe = i(
    (s, l) => ({
      contentRendererParam: R,
      option: l,
      optionKey: s,
      focusedKey: C,
      contentRenderer: F,
      onClick: M,
      onFocus: g,
      optionContainerClassName: L(k, r.listItem)
    }),
    [
      C,
      M,
      g,
      k,
      F,
      R
    ]
  );
  Se(
    o,
    ce,
    K,
    E
  );
  const ue = _e(
    C,
    v,
    h,
    o,
    g,
    c,
    I,
    M,
    se
  ), V = h.length, A = D - V > 0 ? `${n.infoMessageAnd} ${D - V} ${n.infoMessageMore}` : void 0, S = o && !ie;
  return /* @__PURE__ */ _(B, { children: [
    /* @__PURE__ */ e(
      he,
      {
        ...G,
        containerRef: E,
        inputSectionRef: j,
        disabled: p,
        readOnly: a,
        required: H,
        actions: /* @__PURE__ */ _(B, { children: [
          $,
          !a && T && /* @__PURE__ */ e(
            w,
            {
              onClick: T,
              disabled: p,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              title: n.buttonTitleSelect,
              children: /* @__PURE__ */ e(me, { className: r.icon })
            }
          ),
          !a && !Y && ne && /* @__PURE__ */ e(
            w,
            {
              onClick: Z,
              disabled: p,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              title: n.buttonTitleClear,
              children: /* @__PURE__ */ e(de, { className: r.icon })
            }
          ),
          !a && /* @__PURE__ */ e(
            w,
            {
              onClick: ae,
              colorVariant: "text",
              styleVariant: "action",
              name: void 0,
              title: S ? n.buttonTitleClose : n.buttonTitleOpen,
              children: S ? /* @__PURE__ */ e(fe, { className: r.icon }) : /* @__PURE__ */ e(Ce, { className: r.icon })
            }
          )
        ] }),
        input: /* @__PURE__ */ e(
          Me,
          {
            name: d,
            elementRef: y,
            readOnly: a,
            disabled: p,
            value: o || oe ? z : f,
            onChange: re,
            onClick: le,
            onFocus: () => x(!0),
            onBlur: () => x(!1),
            placeholder: ge(f) ? f : X,
            autoComplete: "off",
            onKeyDown: ue,
            autoFocus: te
          }
        )
      }
    ),
    S && /* @__PURE__ */ _(
      Ie,
      {
        elementRef: K,
        parentRef: j,
        className: L(Q, r.popup),
        children: [
          /* @__PURE__ */ e(
            ye,
            {
              className: r.list,
              data: h,
              keySelector: v,
              renderer: be,
              rendererParams: pe,
              errored: O,
              filtered: ee,
              pending: N,
              pendingMessage: n.selectInputPendingMessage,
              emptyMessage: n.selectInputEmptyMessage,
              filteredEmptyMessage: n.selectInputFilteredMessage,
              errorMessage: n.selectInputErrorMessage,
              compact: !0
            }
          ),
          !N && !O && !!A && /* @__PURE__ */ e("div", { className: r.infoMessage, children: A })
        ]
      }
    )
  ] });
}
export {
  Ze as default
};
